const colorMap = {
  STRUGGLING: "#EA271A", // RED
  "NOT STARTED": "#EAB80F", // Yellow
  STARTED: "#0F9EEA", // Blue
  COMPLETED: "#1B9808", // Green
};

export { colorMap };
